import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-BellShape",
  "use": "svg-icon-BellShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-BellShape\"><g fill=\"none\"><path d=\"M0 0h24v24H0z\" /><path d=\"M4.667 10.192C4.667 6.22 7.95 3 12 3c4.05 0 7.333 3.22 7.333 7.192v4.577L22 17.385V20H2v-2.615l2.667-2.616v-4.577zM10 4V2h4v2m-1.167 14c1.148.418 1.837 1.626 1.63 2.862C14.259 22.097 13.218 23 12 23s-2.258-.903-2.464-2.138c-.206-1.236.483-2.444 1.63-2.862\" fill=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol